export const FREE_DELIVERY_FROM_PRICE = 49.99;
export const CURRENCY = "€ ";
export const CURRENCY_CODE = "EUR";
export const DELIVERY_OPTIONS = {
  PICKUP: "pickup",
  SEND: "send",
};

export const PAYMENT_METHODS = {
  CREDITCARD: "creditcard",
  IDEAL: "ideal",
  BANCONTACT: "bancontact",
};

export const ADDRESS_TYPES = {
  DELIVERY: "DELIVERY",
  INVOICE: "INVOICE",
};

export const SHIPPING_COST_NL_BE = 50;
export const SHIPPING_COST_DE = 75;
export const SHIPPING_COST_NL_BE_UNTIL = 1250;
export const SHIPPING_COST_DE_UNTIL = 1500;
